import type { ResourceConfig } from "../types";

export const reviewCourseConfig = {
  displayName: "课程复习",
  category: "review-course",
  permissions: {
    "read:all": {
      label: "访问课程复习",
      description: "可以访问课程复习功能",
    },
    "write:all": {
      label: "管理课程复习",
      description: "可以管理课程复习内容（仅管理员）",
    },
  },
} satisfies ResourceConfig;
